import { Box, SxProps, Theme } from '@mui/material';
import { ChangeEvent, useCallback } from 'react';
import { LookupSelect } from 'shared/components/LookupSelect';
import { Customer } from 'shared/types/customer';

const containerStyles: SxProps<Theme> = {
  flex: '1 0 auto',
  padding: '15px 0 15px 0',
};

interface CustomerInputProps {
  onSelect: (c: Customer) => void;
}

export const CustomerInput = ({ onSelect }: CustomerInputProps) => {
  const handleSelect = useCallback(
    (e: ChangeEvent<{}>, c: string | Customer | null) => {
      if (typeof c === 'string' || !c) return;
      onSelect(c);
    },
    [onSelect]
  );

  return (
    <Box sx={containerStyles}>
      <LookupSelect<Customer>
        clientId='demo-plq'
        columnName='customer_name'
        dataType='string'
        getOptionLabel={opt => opt.customer_name}
        handleSelect={handleSelect}
        inputCasing='UPPERCASE'
        queryOperator='contains'
        tableId='customermasteranonts'
        title='Search customers'
      />
    </Box>
  );
};
